import { gql } from '@apollo/client'

export const CANCEL_POLICIES_QUERY = gql`
  query CancelPolicies($providerCode: String!) {
    cancelPolicies(providerCode: $providerCode) {
      basicDetails {
        name
        description
        descriptionTranslatedList {
          label
          value
          nativeLabel
        }
        id
      }
      table {
        applied
        priority
        penaltyAmount
        deadline
        deadlineTimeOffset
        penaltyType
        policyType
      }
    }
  }
`
export const CANCEL_POLICY_QUERY = gql`
  query CancelPolicy($providerCode: String!, $policyID: String!) {
    cancelPolicy(providerCode: $providerCode, policyID: $policyID) {
      basicDetails {
        name
        description
        descriptionTranslatedList {
          label
          value
          nativeLabel
        }
        id
      }
      table {
        applied
        priority
        penaltyAmount
        deadline
        deadlineTimeOffset
        penaltyType
        policyType
      }
    }
  }
`

export const CANCEL_POLICY_GENERATE = gql`
  mutation generateCancelPolicy(
    $input: CancelPolicyInput!
    $providerCode: String!
  ) {
    generateCancelPolicy(input: $input, providerCode: $providerCode) {
      message
    }
  }
`
export const CANCEL_POLICY_MODIFY = gql`
  mutation ModifyCancelPolicy(
    $input: CancelPolicyInput!
    $providerCode: String!
  ) {
    modifyCancelPolicy(input: $input, providerCode: $providerCode) {
      message
    }
  }
`
